import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SousBienService } from 'app/services/sousBiens/sous-bien.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-liste-sous-biens',
  templateUrl: './liste-sous-biens.component.html',
  styleUrls: ['./liste-sous-biens.component.scss']
})
export class ListeSousBiensComponent implements OnInit {
  
  dataSource = new MatTableDataSource();
  public search: string  = ''

  sousBiens : any
  constructor(private sousBienService:SousBienService) { }

  getData() {
    this.sousBienService.getListSousBien().subscribe((data) => {
      this.sousBiens = data;
    });
  }
  ngOnInit() {
    this.sousBienService.refreshNedeed.subscribe(() => this.getData());
    this.getData()
  }



  deletesousBien(agencieProjet: any) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.sousBienService.deleteSousBien(agencieProjet.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
          // this.AgenciesTunis.splice(i,1)
  
          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
         
        }); setTimeout(() => {
          this.getData()
          }, 500);
        
      }
    });
  }
  
}
